import React from "react";

const ModalStepContext = React.createContext();
ModalStepContext.displayName = "ModalStepContext";

export default ModalStepContext;